﻿import Grid2 from "@mui/material/Grid2";
import { type ReactNode, useState } from "react";
import Statistics from "./statistics";

interface TabPanelProps {
	children?: ReactNode;
	index: number;
	value: number;
}

function TabPanel(props: TabPanelProps) {
	const { children, value, index } = props;

	return (
		<>
			{value === index && (
				<Grid2
					style={{ height: "100%", width: "100%" }}
					size={{ md: 12, xs: 12 }}
				>
					{children}
				</Grid2>
			)}
		</>
	);
}

type Props = {
	isStatisticsLoading: boolean;
};

export default function StatisticsTabs({ isStatisticsLoading }: Props) {
	//Tabs and Toggle Buttons
	const [value, setValue] = useState<number>(0);

	return (
		<>
			<Grid2
				container
				sx={{
					"& .MuiGrid-root": {
						padding: 0,
					},
					"& .MuiBox-root": {
						padding: 0,
					},
				}}
				style={{ height: "100%" }}
			>
				<TabPanel value={value} index={0}>
					<Statistics isStatisticsLoading={isStatisticsLoading} />
				</TabPanel>
			</Grid2>
		</>
	);
}
